<template>
  <div :class="{ fullscreen: fullscreen }" class="tinymce-container">
    <textarea :id="tinymceId" class="tinymce-textarea" />
  </div>
</template>

<script>
import configure from "./plugins.js";
import load from "./dynamicLoadScript.js";
// import '../../../public/vendor/js/tinymce.min';
// import '../../assets/js/tinymce.js';
// const tinymceCDN = 'https://cdn.jsdelivr.net/npm/tinymce-all-in-one@4.9.3/tinymce.min.js';
// const tinymceCDN = "https://unpkg.com/tinymce-all-in-one@4.9.3/tinymce.min.js";

export default {
  name: "Tinymce",
  props: {
    value: {
      type: String,
      default: "",
    },
    height: {
      type: [Number, String],
      required: false,
      default: 300,
    },
    uploaderData: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      hasChange: false,
      hasInit: false,
      tinymceId:
        "vue-tinymce-" + +new Date() + ((Math.random() * 1000).toFixed(0) + ""),
      fullscreen: false,
      languageTypeList: {
        zh: "zh_CN",
        ja: "ja",
      },
      lang: "",
      resimg: "", //上传img的url
      uploaded: false, //有没有上传完
    };
  },

  computed: {},

  watch: {
    value(val) {
      if (this.$refs["tinymce"] !== undefined) {
        this.$refs["tinymce"].setContent(this.form.text);
      }
      if (!this.hasChange && this.hasInit) {
        this.$nextTick(() =>
          window.tinymce.get(this.tinymceId).setContent(val || "")
        );
      }
      if (this.$refs["tinymce"] !== undefined) {
        this.$refs["tinymce"].setContent(val);
      }
    },
  },
  created() {},
  mounted() {
    this.init();

    var taht = this;
    setTimeout(function () {
      if (window.tinymce) {
        if (window.tinymce.get(taht.tinymceId)) {
          if (window.tinymce.get(taht.tinymceId).contentWindow) {
            var tinymce_body = window.tinymce.get(taht.tinymceId).contentWindow
              .document;
            tinymce_body.styleSheets[0].insertRule(
              "#tinymce p{margin-top: 0; margin-bottom: 0;}",
              0
            );
            tinymce_body.styleSheets[0].insertRule(
              "#tinymce{font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', SimSun, sans-serif;}",
              0
            );
          }
        }
      }
    }, 1000);
  },

  activated() {
    // this.initTinymce();
    console.log("激活");
    if (window.tinymce) {
      this.initTinymce();
    }
  },

  deactivated() {
    this.destroyTinymce();
  },

  destroyed() {
    this.destroyTinymce();
    clearInterval(this.timer);
  },

  methods: {
    init() {
      this.initTinymce();
      // load(tinymceCDN, (err) => {
      //   if (err) {
      //     this.$message.error(err.message);
      //     return;
      //   }
      //   this.initTinymce();
      // });

      // this.initTinymce();
    },

    initTinymce() {
      const _this = this;
      window.tinymce.init({
        selector: `#${this.tinymceId}`,
        auto_focus: false,
        branding: false,
        file_picker_types: "image media",
        language: "zh_CN",
        height: this.height,
        menubar: false,
        body_class: "panel-body",
        object_resizing: false,
        plugins: configure.plugins,
        toolbar: configure.toolbar,
        fontsize_formats: configure.fontsize,
        font_formats: configure.fontfamily,
        end_container_on_empty_block: true,
        powerpaste_word_import: "clean",
        advlist_bullet_styles: "square",
        advlist_number_styles: "default",
        imagetools_cors_hosts: ["www.tinymce.com", "codepen.io"],
        default_link_target: "_blank",
        link_title: false,
        nonbreaking_force_tab: true,
        resize: false, //控制是否可以拖拽
        file_picker_callback: function (callback, value, meta) {
          if (meta.filetype == "image") {
            let input = document.createElement("input"); //创建一个隐藏的input
            input.setAttribute("type", "file");
            // let that = this;
            input.onchange = function () {
              let file = this.files[0]; //选取第一个文件
              // console.log(file)
              _this.uploadImg(file, "image"); // 上传视频拿到url
              console.log(_this.uploaded);
              if (_this.uploaded) {
                // _this.resVideo,
                console.log(_this.resimg, "true");
                callback(_this.resimg); //将url显示在弹框输入框中
              } else {
                setTimeout(() => {
                  //设置几秒后再去取数据
                  console.log(_this.resimg, "false");
                  callback(_this.resimg);
                }, 1000);
              }
            };
            //触发点击
            input.click();
          }
        },
        init_instance_callback: (editor) => {
          if (_this.value) {
            editor.setContent(_this.value);
          }
          _this.hasInit = true;
          editor.on("NodeChange Change KeyUp SetContent", () => {
            _this.hasChange = true;
            _this.$emit("input", editor.getContent());
          });
        },
        setup(editor) {
          editor.on("FullscreenStateChanged", (e) => {
            _this.fullscreen = e.state;
          });
        },
      });
    },

    destroyTinymce() {
      //   return;
      const tinymce = window.tinymce.get(this.tinymceId);
      if (this.fullscreen) {
        tinymce.execCommand("mceFullScreen");
      }

      if (tinymce) {
        tinymce.destroy();
      }
    },

    setContent(value) {
      window.tinymce.get(this.tinymceId).setContent(value);
    },

    getContent() {
      window.tinymce.get(this.tinymceId).getContent();
    },
    // 上传本地图片
    uploadImg(file, type) {
      // console.log(file,type)
      let content = file;
      let uploadData = this.uploaderData;
      let formData = new FormData();
      formData.append("file", this.uploaderData.file);
      formData.append("name", this.uploaderData.name);
      formData.append("file", content);
      // console.log('formData',formData);
      axios({
        method: "post",
        //服务器上传地址
        url: env.API_HOST + "upload/image",
        data: formData,
        headers: {
          // 修改请求头
          "X-JPN-Authorization": localStorage.getItem("token"),
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.resimg = env.PHOTO_HOST + res.data.date.path;
          this.uploaded = true;
        }
      });
    },
  },
};
</script>

<style>
#tinymce p {
  font-family: "STXihei", "sans-serif", "DroidSans";
  font-size: 12px !important;
}
.tinymce-container {
  position: relative;
  line-height: normal;
  margin-bottom: 20px;
}
.tinymce-container >>> .mce-fullscreen {
  z-index: 10000;
}
/*.tinymce-textarea {
  visibility: hidden;
  z-index: -1;
}
.editor-custom-btn-container {
  position: absolute;
  right: 4px;
  top: 4px;
}
.fullscreen .editor-custom-btn-container {
  z-index: 10000;
  position: fixed;
}
.editor-upload-btn {
  display: inline-block;
}

.tinymce-container{
  padding-right: 0.75rem;
  padding-left: 0px;
}

.tinymce-container .mce-branding{
  display: none;
}

.tinymce-container .mce-panel{
  border: 1px solid rgba(24, 28, 33, 0.1);
}
.tinymce-container .mce-tinymce{
  box-shadow: none;
}
.mce-container-body .mce-toolbar-grp{
  box-shadow: none;
  outline: none;
  border: none;
}
.mce-container, .mce-container *, .mce-widget, .mce-widget *, .mce-reset{
  white-space: normal !important;
}*/
</style>
